/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Ai_Usage_Limit_ExceededInputs */

const en_toast_ai_usage_limit_exceeded = /** @type {(inputs: Toast_Ai_Usage_Limit_ExceededInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You've reached your AI usage limit. Please try again later.`)
};

const nl_toast_ai_usage_limit_exceeded = /** @type {(inputs: Toast_Ai_Usage_Limit_ExceededInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je hebt je AI-gebruikslimiet bereikt. Probeer het later opnieuw.`)
};

/**
* | output |
* | --- |
* | "You've reached your AI usage limit. Please try again later." |
*
* @param {Toast_Ai_Usage_Limit_ExceededInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const toast_ai_usage_limit_exceeded = /** @type {((inputs?: Toast_Ai_Usage_Limit_ExceededInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Ai_Usage_Limit_ExceededInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_toast_ai_usage_limit_exceeded(inputs)
	return en_toast_ai_usage_limit_exceeded(inputs)
});